import React, {Component} from "react";
import {
    Accordion, AccordionDetails,
    AccordionSummary,
    Chip, Divider, Fab,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup, Rating
} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {filterValueNice, filterRatingValueNice} from "../utils/filterHelper";

class BookFilter extends Component {

    render() {
        // Parent Variables
        const allCount = this.props.allCount;
        const unreadCount = this.props.unreadCount;
        const readingCount = this.props.readingCount;
        const completedCount = this.props.completedCount;
        const filterValue = this.props.filterValue;
        const filterRatingValue = this.props.filterRatingValue;

        // Parent Functions
        const filterShow = this.props.filterShow;
        const filterByRating = this.props.filterByRating;

        return (
            <div className="filter-container">

                <Accordion>
                    <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon="chevron-down"/>}
                        aria-controls="filter-content"
                        id="filter-header"
                    >
                        <div className="title">
                            Filter
                            <Chip label={filterValueNice(filterValue)} className="title-chip"/>
                            <Chip icon={<FontAwesomeIcon icon="star"/>} label={filterRatingValueNice(filterRatingValue)} className="title-chip"/>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl className="filter-form-control">
                            <div className="status-filter">
                                <div className="title">Status</div>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={filterValue}
                                    onChange={(event) => filterShow(event.target.value)}
                                >
                                    <div className="radio-control">
                                        <FormControlLabel className="radio-label" value="all" control={<Radio />} label={"All"} />
                                        <Chip label={allCount} className="filter-count-chip"/>
                                    </div>

                                    <div className="radio-control">
                                        <FormControlLabel className="radio-label" value="unread" control={<Radio />} label="Unread" />
                                        <Chip label={unreadCount} className="filter-count-chip"/>
                                    </div>

                                    <div className="radio-control">
                                        <FormControlLabel className="radio-label" value="reading" control={<Radio />} label="Reading" />
                                        <Chip label={readingCount} className="filter-count-chip"/>
                                    </div>

                                    <div className="radio-control">
                                        <FormControlLabel className="radio-label" value="completed" control={<Radio />} label="Completed" />
                                        <Chip label={completedCount} className="filter-count-chip"/>
                                    </div>
                                </RadioGroup>
                            </div>

                            <Divider />

                            <div className="rating-filter">
                                <div className="title">Rating</div>
                                <Rating
                                    name="simple-controlled"
                                    value={filterRatingValue}
                                    className="rating-filter-control"
                                    onChange={(event, newValue) => {
                                        if (!newValue) {
                                            newValue = 0;
                                        }
                                        filterByRating(newValue);
                                    }}
                                />
                                {filterRatingValue > 0 &&
                                    <Fab className="rating-filter-clear" size="small" onClick={() => filterByRating(0)}>
                                        <FontAwesomeIcon icon="times"/> Clear
                                    </Fab>
                                }
                            </div>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>

            </div>
        );
    }

}

export default BookFilter;
